export default "__VITE_ASSET__rmBxf3QM__"